<div class="mb-4 settings" style="min-width: 320px; max-width: 70vw">
  <div
    class="setting-container overflow-scroll overflow-x-hidden scroll custom-scrollbar pe-2 mb-3"
  >
    <div class="row">
      <div class="d-flex justify-content-between">
        <div><h2 class="fw-bold">Configurações</h2></div>
      </div>
      <hr />
    </div>
    <div>
      <app-settings-general></app-settings-general>
      <hr class="mt-4 mb-3" />
      <div>
        <h2>Proposta de Trabalho</h2>
        <h3 class="fw-medium">Geral</h3>
        <div
          class="border-4 border-danger rounded mt-2 mb-4"
          style="box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1)"
        >
          <div>
            <div
              class="d-flex w-100 align-items-center justify-content-between gap-2 p-2 bg-white"
            >
              <div
                class="d-flex align-content-center align-items-center gap-2 ms-2"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.1853 11.6962C23.1525 11.6222 22.3584 9.86062 20.5931 8.09531C18.2409 5.74312 15.27 4.5 12 4.5C8.72999 4.5 5.75905 5.74312 3.40687 8.09531C1.64155 9.86062 0.843741 11.625 0.814679 11.6962C0.772035 11.7922 0.75 11.896 0.75 12.0009C0.75 12.1059 0.772035 12.2097 0.814679 12.3056C0.847491 12.3797 1.64155 14.1403 3.40687 15.9056C5.75905 18.2569 8.72999 19.5 12 19.5C15.27 19.5 18.2409 18.2569 20.5931 15.9056C22.3584 14.1403 23.1525 12.3797 23.1853 12.3056C23.2279 12.2097 23.25 12.1059 23.25 12.0009C23.25 11.896 23.2279 11.7922 23.1853 11.6962ZM12 18C9.11437 18 6.59343 16.9509 4.50655 14.8828C3.65028 14.0313 2.92179 13.0603 2.34374 12C2.92164 10.9396 3.65014 9.9686 4.50655 9.11719C6.59343 7.04906 9.11437 6 12 6C14.8856 6 17.4066 7.04906 19.4934 9.11719C20.3514 9.9684 21.0815 10.9394 21.6609 12C20.985 13.2619 18.0403 18 12 18ZM12 7.5C11.11 7.5 10.2399 7.76392 9.49993 8.25839C8.7599 8.75285 8.18313 9.45566 7.84253 10.2779C7.50194 11.1002 7.41282 12.005 7.58646 12.8779C7.76009 13.7508 8.18867 14.5526 8.81801 15.182C9.44735 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.4988 10.8069 16.0242 9.66303 15.1806 8.81939C14.337 7.97575 13.1931 7.50124 12 7.5ZM12 15C11.4066 15 10.8266 14.8241 10.3333 14.4944C9.83993 14.1648 9.45542 13.6962 9.22835 13.1481C9.00129 12.5999 8.94188 11.9967 9.05764 11.4147C9.17339 10.8328 9.45911 10.2982 9.87867 9.87868C10.2982 9.45912 10.8328 9.1734 11.4147 9.05764C11.9967 8.94189 12.5999 9.0013 13.148 9.22836C13.6962 9.45542 14.1648 9.83994 14.4944 10.3333C14.824 10.8266 15 11.4067 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15Z"
                    fill="#3199D0"
                  />
                </svg>

                <h4 class="fs-6 fw-normal m-0 p-0">Ocultar Entregáveis</h4>
                <button
                  class="btn m-0 p-0 rounded-4"
                  (click)="openDialogHideDeliverables()"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 5.5C10.7144 5.5 9.45772 5.88122 8.3888 6.59545C7.31988 7.30968 6.48676 8.32484 5.99479 9.51256C5.50282 10.7003 5.37409 12.0072 5.6249 13.2681C5.8757 14.529 6.49477 15.6872 7.40381 16.5962C8.31285 17.5052 9.47104 18.1243 10.7319 18.3751C11.9928 18.6259 13.2997 18.4972 14.4874 18.0052C15.6752 17.5132 16.6903 16.6801 17.4046 15.6112C18.1188 14.5423 18.5 13.2856 18.5 12C18.4982 10.2767 17.8128 8.62441 16.5942 7.40582C15.3756 6.18722 13.7234 5.50182 12 5.5ZM12 17.5C10.9122 17.5 9.84884 17.1774 8.94437 16.5731C8.0399 15.9687 7.33495 15.1098 6.91867 14.1048C6.50238 13.0998 6.39347 11.9939 6.60568 10.927C6.8179 9.86011 7.34173 8.8801 8.11092 8.11091C8.8801 7.34172 9.86011 6.8179 10.927 6.60568C11.9939 6.39346 13.0998 6.50238 14.1048 6.91866C15.1098 7.33494 15.9687 8.03989 16.5731 8.94436C17.1774 9.84883 17.5 10.9122 17.5 12C17.4983 13.4582 16.9184 14.8562 15.8873 15.8873C14.8562 16.9184 13.4582 17.4983 12 17.5ZM13 15C13 15.1326 12.9473 15.2598 12.8536 15.3536C12.7598 15.4473 12.6326 15.5 12.5 15.5C12.2348 15.5 11.9804 15.3946 11.7929 15.2071C11.6054 15.0196 11.5 14.7652 11.5 14.5V12C11.3674 12 11.2402 11.9473 11.1464 11.8536C11.0527 11.7598 11 11.6326 11 11.5C11 11.3674 11.0527 11.2402 11.1464 11.1464C11.2402 11.0527 11.3674 11 11.5 11C11.7652 11 12.0196 11.1054 12.2071 11.2929C12.3946 11.4804 12.5 11.7348 12.5 12V14.5C12.6326 14.5 12.7598 14.5527 12.8536 14.6464C12.9473 14.7402 13 14.8674 13 15ZM11 9.25C11 9.10166 11.044 8.95666 11.1264 8.83332C11.2088 8.70999 11.3259 8.61386 11.463 8.55709C11.6 8.50032 11.7508 8.48547 11.8963 8.51441C12.0418 8.54335 12.1754 8.61478 12.2803 8.71967C12.3852 8.82456 12.4567 8.9582 12.4856 9.10368C12.5145 9.24917 12.4997 9.39997 12.4429 9.53701C12.3861 9.67406 12.29 9.79119 12.1667 9.8736C12.0433 9.95601 11.8983 10 11.75 10C11.5511 10 11.3603 9.92098 11.2197 9.78033C11.079 9.63968 11 9.44891 11 9.25Z"
                      fill="#191C1E"
                    />
                  </svg>
                </button>
              </div>
              <div>
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="hideDeliverablesSwitchCheckChecked"
                    mat-stroked-button
                    (click)="setHideDeliverables()"
                    [(ngModel)]="workProposalData.hide_deliverables"
                  />
                </div>
              </div>
            </div>
          </div>
          <hr class="m-1" />

          <div
            class="d-flex w-100 align-items-center justify-content-between gap-2 mb-1 p-2 bg-white"
          >
            <div
              class="d-flex align-content-center align-items-center gap-2 ms-2"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.75 11.25V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V11.25C11.25 11.0511 11.329 10.8603 11.4697 10.7197C11.6103 10.579 11.8011 10.5 12 10.5C12.1989 10.5 12.3897 10.579 12.5303 10.7197C12.671 10.8603 12.75 11.0511 12.75 11.25ZM18.75 18C18.5511 18 18.3603 18.079 18.2197 18.2197C18.079 18.3603 18 18.5511 18 18.75V20.25C18 20.4489 18.079 20.6397 18.2197 20.7803C18.3603 20.921 18.5511 21 18.75 21C18.9489 21 19.1397 20.921 19.2803 20.7803C19.421 20.6397 19.5 20.4489 19.5 20.25V18.75C19.5 18.5511 19.421 18.3603 19.2803 18.2197C19.1397 18.079 18.9489 18 18.75 18ZM21 15H19.5V3.75C19.5 3.55109 19.421 3.36032 19.2803 3.21967C19.1397 3.07902 18.9489 3 18.75 3C18.5511 3 18.3603 3.07902 18.2197 3.21967C18.079 3.36032 18 3.55109 18 3.75V15H16.5C16.3011 15 16.1103 15.079 15.9697 15.2197C15.829 15.3603 15.75 15.5511 15.75 15.75C15.75 15.9489 15.829 16.1397 15.9697 16.2803C16.1103 16.421 16.3011 16.5 16.5 16.5H21C21.1989 16.5 21.3897 16.421 21.5303 16.2803C21.671 16.1397 21.75 15.9489 21.75 15.75C21.75 15.5511 21.671 15.3603 21.5303 15.2197C21.3897 15.079 21.1989 15 21 15ZM5.25 15C5.05109 15 4.86032 15.079 4.71967 15.2197C4.57902 15.3603 4.5 15.5511 4.5 15.75V20.25C4.5 20.4489 4.57902 20.6397 4.71967 20.7803C4.86032 20.921 5.05109 21 5.25 21C5.44891 21 5.63968 20.921 5.78033 20.7803C5.92098 20.6397 6 20.4489 6 20.25V15.75C6 15.5511 5.92098 15.3603 5.78033 15.2197C5.63968 15.079 5.44891 15 5.25 15ZM7.5 12H6V3.75C6 3.55109 5.92098 3.36032 5.78033 3.21967C5.63968 3.07902 5.44891 3 5.25 3C5.05109 3 4.86032 3.07902 4.71967 3.21967C4.57902 3.36032 4.5 3.55109 4.5 3.75V12H3C2.80109 12 2.61032 12.079 2.46967 12.2197C2.32902 12.3603 2.25 12.5511 2.25 12.75C2.25 12.9489 2.32902 13.1397 2.46967 13.2803C2.61032 13.421 2.80109 13.5 3 13.5H7.5C7.69891 13.5 7.88968 13.421 8.03033 13.2803C8.17098 13.1397 8.25 12.9489 8.25 12.75C8.25 12.5511 8.17098 12.3603 8.03033 12.2197C7.88968 12.079 7.69891 12 7.5 12ZM14.25 7.5H12.75V3.75C12.75 3.55109 12.671 3.36032 12.5303 3.21967C12.3897 3.07902 12.1989 3 12 3C11.8011 3 11.6103 3.07902 11.4697 3.21967C11.329 3.36032 11.25 3.55109 11.25 3.75V7.5H9.75C9.55109 7.5 9.36032 7.57902 9.21967 7.71967C9.07902 7.86032 9 8.05109 9 8.25C9 8.44891 9.07902 8.63968 9.21967 8.78033C9.36032 8.92098 9.55109 9 9.75 9H14.25C14.4489 9 14.6397 8.92098 14.7803 8.78033C14.921 8.63968 15 8.44891 15 8.25C15 8.05109 14.921 7.86032 14.7803 7.71967C14.6397 7.57902 14.4489 7.5 14.25 7.5Z"
                  fill="#3199D0"
                />
              </svg>
              <h4 class="fs-6 fw-normal m-0 p-0">Precificação Padrão</h4>
              <button
                class="btn m-0 p-0 rounded-4"
                (click)="openDialogDefaultPricing()"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.75 11.25C8.75 11.3983 8.70602 11.5433 8.6236 11.6667C8.54119 11.79 8.42406 11.8861 8.28701 11.9429C8.14997 11.9997 7.99917 12.0145 7.85368 11.9856C7.7082 11.9566 7.57456 11.8852 7.46967 11.7803C7.36478 11.6754 7.29335 11.5418 7.26441 11.3963C7.23548 11.2508 7.25033 11.1 7.30709 10.963C7.36386 10.8259 7.45999 10.7088 7.58333 10.6264C7.70666 10.544 7.85167 10.5 8 10.5C8.19892 10.5 8.38968 10.579 8.53033 10.7197C8.67098 10.8603 8.75 11.0511 8.75 11.25ZM8 4.5C6.62125 4.5 5.5 5.50938 5.5 6.75V7C5.5 7.13261 5.55268 7.25979 5.64645 7.35355C5.74022 7.44732 5.86739 7.5 6 7.5C6.13261 7.5 6.25979 7.44732 6.35356 7.35355C6.44732 7.25979 6.5 7.13261 6.5 7V6.75C6.5 6.0625 7.17313 5.5 8 5.5C8.82688 5.5 9.5 6.0625 9.5 6.75C9.5 7.4375 8.82688 8 8 8C7.86739 8 7.74022 8.05268 7.64645 8.14645C7.55268 8.24021 7.5 8.36739 7.5 8.5V9C7.5 9.13261 7.55268 9.25979 7.64645 9.35355C7.74022 9.44732 7.86739 9.5 8 9.5C8.13261 9.5 8.25979 9.44732 8.35356 9.35355C8.44732 9.25979 8.5 9.13261 8.5 9V8.955C9.64 8.74563 10.5 7.83625 10.5 6.75C10.5 5.50938 9.37875 4.5 8 4.5ZM14.5 8C14.5 9.28558 14.1188 10.5423 13.4046 11.6112C12.6903 12.6801 11.6752 13.5132 10.4874 14.0052C9.29973 14.4972 7.99279 14.6259 6.73192 14.3751C5.47104 14.1243 4.31285 13.5052 3.40381 12.5962C2.49477 11.6872 1.8757 10.529 1.6249 9.26809C1.37409 8.00721 1.50282 6.70028 1.99479 5.51256C2.48676 4.32484 3.31988 3.30968 4.3888 2.59545C5.45772 1.88122 6.71442 1.5 8 1.5C9.72335 1.50182 11.3756 2.18722 12.5942 3.40582C13.8128 4.62441 14.4982 6.27665 14.5 8ZM13.5 8C13.5 6.9122 13.1774 5.84883 12.5731 4.94436C11.9687 4.03989 11.1098 3.33494 10.1048 2.91866C9.09977 2.50238 7.9939 2.39346 6.92701 2.60568C5.86011 2.8179 4.8801 3.34172 4.11092 4.11091C3.34173 4.8801 2.8179 5.86011 2.60568 6.927C2.39347 7.9939 2.50238 9.09977 2.91867 10.1048C3.33495 11.1098 4.0399 11.9687 4.94437 12.5731C5.84884 13.1774 6.91221 13.5 8 13.5C9.45819 13.4983 10.8562 12.9184 11.8873 11.8873C12.9184 10.8562 13.4983 9.45818 13.5 8Z"
                    fill="#0B0C0E"
                  />
                </svg>
              </button>
            </div>
            <div>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  checked
                  mat-stroked-button
                  (click)="defaultPricingAlert()"
                  [(ngModel)]="workProposalData.default_pricing"
                  (ngModelChange)="setDefaultPricing()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h3 class="fw-medium">Oferta</h3>
      <header
        *ngIf="dataStoreSetting.defaultPricing"
        class="w-100 align-items-center gap-2 rounded mb-5"
        style="
          background-color: #f7f7f7;
          box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
          border-left: 5px solid #c5c5c5;
        "
      >
        <div class="row justify-content-between">
          <div class="col">
            <h4 class="fs-6 mt-3 fw-medium ms-3" style="color: #43474e">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.3113 6.87846L17.1216 2.68971C16.9823 2.55038 16.8169 2.43986 16.6349 2.36446C16.4529 2.28905 16.2578 2.25024 16.0608 2.25024C15.8638 2.25024 15.6687 2.28905 15.4867 2.36446C15.3047 2.43986 15.1393 2.55038 15 2.68971L3.43969 14.25C3.2998 14.3888 3.18889 14.554 3.11341 14.736C3.03792 14.9181 2.99938 15.1133 3.00001 15.3103V19.5C3.00001 19.8978 3.15804 20.2794 3.43935 20.5607C3.72065 20.842 4.10218 21 4.50001 21H20.25C20.4489 21 20.6397 20.921 20.7803 20.7803C20.921 20.6397 21 20.4489 21 20.25C21 20.0511 20.921 19.8603 20.7803 19.7197C20.6397 19.579 20.4489 19.5 20.25 19.5H10.8113L21.3113 9.00002C21.4506 8.86073 21.5611 8.69535 21.6365 8.51334C21.7119 8.33133 21.7507 8.13625 21.7507 7.93924C21.7507 7.74222 21.7119 7.54714 21.6365 7.36513C21.5611 7.18312 21.4506 7.01775 21.3113 6.87846ZM8.68969 19.5H4.50001V15.3103L12.75 7.06033L16.9397 11.25L8.68969 19.5ZM18 10.1897L13.8113 6.00002L16.0613 3.75002L20.25 7.93971L18 10.1897Z"
                  fill="#c5c5c5"
                />
              </svg>
              Edição
            </h4>
          </div>

          <div class="col-auto">
            <p class="mt-3 me-4" style="color: #43474e">
              Desabilite a precificação padrão caso queira editar.
            </p>
          </div>
        </div>
      </header>
      <app-offer
        *ngIf="!workProposalData.default_pricing"
        [data]="workProposalData"
      ></app-offer>
      <!-- <app-settings-job-offer></app-settings-job-offer> -->
      <!-- <app-settings-plans></app-settings-plans> -->
    </div>

    <div class="row">
      <app-preview></app-preview>
    </div>
  </div>
  <div
    class="setting-footer w-100 position-fixed bottom-0 mb-2 border-top"
    style="max-width: 70vw; background-color: #f9f9fb"
  >
    <div class="m-2">
      <footer class="pt-3 mx-4">
        <div class="d-flex justify-content-end">
          <!-- <button
            class="btn btn-outline-primary border-dark-subtle fw-bolder"
            routerLink="/job-offer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M20.9996 12.0001C20.9996 12.199 20.9206 12.3897 20.7799 12.5304C20.6393 12.671 20.4485 12.7501 20.2496 12.7501H5.55993L11.0302 18.2194C11.0999 18.2891 11.1552 18.3718 11.1929 18.4629C11.2306 18.5539 11.25 18.6515 11.25 18.7501C11.25 18.8486 11.2306 18.9462 11.1929 19.0372C11.1552 19.1283 11.0999 19.211 11.0302 19.2807C10.9606 19.3504 10.8778 19.4056 10.7868 19.4433C10.6957 19.4811 10.5982 19.5005 10.4996 19.5005C10.4011 19.5005 10.3035 19.4811 10.2124 19.4433C10.1214 19.4056 10.0387 19.3504 9.96899 19.2807L3.21899 12.5307C3.14926 12.461 3.09394 12.3783 3.05619 12.2873C3.01845 12.1962 2.99902 12.0986 2.99902 12.0001C2.99902 11.9015 3.01845 11.8039 3.05619 11.7128C3.09394 11.6218 3.14926 11.5391 3.21899 11.4694L9.96899 4.71943C10.1097 4.5787 10.3006 4.49963 10.4996 4.49963C10.6986 4.49963 10.8895 4.5787 11.0302 4.71943C11.171 4.86016 11.25 5.05103 11.25 5.25005C11.25 5.44907 11.171 5.63995 11.0302 5.78068L5.55993 11.2501H20.2496C20.4485 11.2501 20.6393 11.3291 20.7799 11.4697C20.9206 11.6104 20.9996 11.8011 20.9996 12.0001Z"
              />
            </svg>

            <span> Proposta de Trabalho </span>
          </button> -->
          <button (click)="saveForm()" class="btn btn-primary fw-bolder">
            Salvar Edições
          </button>
        </div>
      </footer>
    </div>
  </div>
</div>
